import { render } from "./AssignMentors.vue?vue&type=template&id=b8205258&scoped=true"
import script from "./AssignMentors.vue?vue&type=script&lang=js"
export * from "./AssignMentors.vue?vue&type=script&lang=js"

import "./AssignMentors.vue?vue&type=style&index=0&id=b8205258&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8205258"]])

export default __exports__